import React, { useRef } from "react";
import Footer from "../../components/footer/Footer";
import JokerProHeader from "../../components/header/JokerVideoHeader";
import { useTranslation } from "react-i18next";
import AssetsPack from "../../util/AssetsPack";
import MainTemplate from "../Templates/MainTemplate";
import style from "./JokerScratch.module.css";
import { HorizontalScrollGradientColor } from "../../components/JokerHorizontalList";
import TitleSectionChild from "../../components/TitleSectionChild";
import GameSection from "../../components/GameSection";
import {
  jokerScratchGameCards,
  jokerScratchList,
  sugarGsapList,
  sugarScratches,
  turboGsapList,
  turboScratchs,
} from "../../util/CollectionData";
import TwoToneHorizontalSectionChild from "../../components/TwoToneHorizontalSectionChild";
import { ButtonType, JokerButton } from "material-ui-jokerpro";
import LandscapeView from "../../components/LandscapeView";
import ProductInfo from "../../components/ProductInfo";
import DownloadFooter from "../../components/downloadFooter/DownloadFooter";
import { ParentGames } from "../../util/AllCardsGames";

const JokerScratch = () => {
  const { t } = useTranslation();
  const sugarScratchRef = useRef<HTMLDivElement>(null);
  const turboScratchRef = useRef<HTMLDivElement>(null);

  const onCardClick = (card: any) => {
    if (
      card.label === t("joker_scratch_page.sugar_scratch") &&
      sugarScratchRef.current
    ) {
      sugarScratchRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else if (
      card.label === t("joker_scratch_page.turbo_scratch") &&
      turboScratchRef.current
    ) {
      turboScratchRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const header = (
    <JokerProHeader
      headerText={t("nav_bar.joker_scratch")}
      title={t("joker_scratch_page.title_tone_1")}
      highlightLabel={t("joker_scratch_page.title_tone_2")}
      description={t("joker_scratch_page.sub_title")}
      bgImage={AssetsPack.image.BG_JOKER_SCRATCH_HEADER}
      image={AssetsPack.image.JOKER_SCRATCH_HEADER}
    >
      <div className={style["button-container"]}>
        {jokerScratchGameCards
          .filter((data) => data.isDisable == false)
          .map((data, index) => (
            <JokerButton
              key={index}
              text={data.label}
              onClick={() => onCardClick(data)}
              type={ButtonType.CTA}
              icon={`${AssetsPack.icons.REDIRECT_ARROW.default}`}
            />
          ))}
      </div>
    </JokerProHeader>
  );

  const landscapeOnClick = (type: string) => {
    if (type == ParentGames.TURBO) {
      turboScratchRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      sugarScratchRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const landscapeView = (
    <div className={style["landscape-container"]}>
      <TwoToneHorizontalSectionChild
        titleTone1={t("joker_scratch_page.landscape_card_title_tone_1")}
        titleTone2={t("joker_scratch_page.landscape_card_title_tone_2")}
        description={t("joker_scratch_page.landscape_card_description")}
      >
        <div className={style["landscape-information"]}>
          <LandscapeView list={jokerScratchList} onClick={landscapeOnClick} />
        </div>
      </TwoToneHorizontalSectionChild>
    </div>
  );

  const turboScratch = (
    <div ref={turboScratchRef} className={style["turbo_scratch"]}>
      <TitleSectionChild
        tag={t("global_component.introducing")}
        title={t("turbo_scratch.title")}
        description={t("turbo_scratch.description")}
      >
        <ProductInfo itemList={turboGsapList} black1100 />
        <GameSection
          item={turboScratchs}
          gradientColor={HorizontalScrollGradientColor.GRAY}
          isLearnVideoAvailable={false}
          title={t("joker_scratch_page.turbo.title_tone_1")}
          title2={t("joker_scratch_page.turbo.title_tone_2")}
          description={t("joker_scratch_page.turbo.description")}
        />
      </TitleSectionChild>
    </div>
  );

  const sugarScratch = (
    <div ref={sugarScratchRef} className={style["sugar_scratch"]}>
      <TitleSectionChild
        tag={t("global_component.coming_soon")}
        title={t("joker_scratch_page.sugar.title")}
        description={t("sugar_scratches.description")}
      >
        <ProductInfo itemList={sugarGsapList} />

        <GameSection
          item={sugarScratches}
          isLearnVideoAvailable={false}
          title={t("joker_scratch_page.sugar.title_tone_1")}
          title2={t("joker_scratch_page.sugar.title_tone_2")}
          description={t("joker_scratch_page.sugar.description")}
        />
      </TitleSectionChild>
    </div>
  );
  const body = (
    <div className={style["body-container"]}>
      {landscapeView}
      {turboScratch}
      {sugarScratch}
      <div className={style["download-container"]}>
        <DownloadFooter />
      </div>
    </div>
  );

  return (
    <MainTemplate
      body={body}
      footer={<Footer />}
      header={header}
      fullWidthHeaderIpad
    />
  );
};

export default JokerScratch;
